'use client';

import classNames from 'classnames';
import React, { useState } from 'react';

export const FormCtaNewsletter = () => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [message, setMessage] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setIsSubmitting(true);
        setMessage('');

        const formData = new FormData(e.currentTarget);
        const email = formData.get('email') as string;

        try {
            const response = await fetch('/.netlify/functions/newsletter-signup', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({ email }),
            });

            const result = await response.json();

            if (response.ok) {
                setIsSuccess(true);
                setMessage('Thank you for subscribing!');
                (e.target as HTMLFormElement).reset();
            } else {
                setIsSuccess(false);
                setMessage(result.error || 'Something went wrong. Please try again.');
            }
        } catch (error) {
            setIsSuccess(false);
            setMessage('Oops there was an error. Please try again.');
            console.error('Newsletter signup error:', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <form onSubmit={handleSubmit} className="w-full">
            <div className="relative flex flex-row">
                <div className="flex-auto">
                    <div className="form-group">
                        <label className="label-overline" htmlFor="email">
                            EMAIL ADDRESS
                        </label>
                        <input
                            className="placeholder-gray-900 form-control bg-green-300"
                            name="email"
                            type="email"
                            placeholder="Email Address"
                            required
                            disabled={isSubmitting}
                        />
                    </div>
                </div>
                <div className="absolute bottom-[2px] right-4">
                    <button
                        className="hover:clickable disabled:opacity-50"
                        type="submit"
                        aria-label="submit newsletter signup"
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? (
                            <div className="w-6 h-6 border-2 border-gray-900 rounded-full border-t-transparent animate-spin"></div>
                        ) : (
                            <svg
                                width="24"
                                height="24"
                                xmlns="http://www.w3.org/2000/svg"
                                fillRule="evenodd"
                                clipRule="evenodd"
                            >
                                <path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z" />
                            </svg>
                        )}
                    </button>
                </div>
                {message && (
                    <div
                        className={classNames(`absolute -bottom-12 w-full mt-3 text-sm px-3 pt-3 pb-2`, {
                            'bg-green-400': isSuccess,
                            'bg-poppy text-white': !isSuccess,
                        })}
                    >
                        {message}
                    </div>
                )}
            </div>
        </form>
    );
};

export const CtaNewsletter = () => {
    const leftSectionMessage =
        'Want to stay in the loop? Sign-up for our quarterly newsletter and we’ll send you updates with a mix of our latest content.';
    return (
        <div className="bg-linear-to-r from-green-400 to-green-300">
            <div className="w-full mx-auto max-w-container">
                <div className="grid-cols-1 gap-0 md:grid md:grid-cols-14">
                    <div className="col-start-1 px-6 py-8 md:px-0 md:py-20 md:col-span-6 md:col-start-2 bg-green-400">
                        <div className="grid grid-cols-6">
                            <div className="col-span-5">
                                <h4 className="h-md">{leftSectionMessage}</h4>
                            </div>
                        </div>
                    </div>
                    <div className="px-6 md:col-span-6 md:px-0 bg-green-300">
                        <div className="grid h-full grid-cols-6">
                            <div className="h-full col-span-6 md:col-span-5 md:col-start-2">
                                <div className="flex items-center h-full pt-2 pb-8">
                                    <FormCtaNewsletter />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CtaNewsletter;
